<script>
    import { getContext } from "svelte";
    import * as util from "../js/util.js";
    import Plus from "../Vectors/Plus.svelte";
    import CustomSelectBox from "../SharedComponents/CustomSelectBox.svelte";
    import AddCountryVersion from "./AddCountryVersion.svelte";
    import { countryStore } from "../store/Countries.js";
    import { languageTextsStore } from "../store/languageTexts.js";
    import { Tabs, Tab, TabList, TabPanel } from "svelte-tabs";
    import { listen } from "svelte/internal";
    import Table from "../SharedComponents/Table.svelte";
    import { link, navigate } from "svelte-routing";
    const { snackbar } = getContext("app");

    export let id;
    let currentCountry;
    $: bs = countryStore.getCountry(id);
    $: currentCountry = $countryStore && $countryStore.currentCountry;
    $: langs = $countryStore.langs;
    const { open } = getContext("modal");
    countryStore.getCountries();
    async function save() {
        await countryStore.saveCountry(currentCountry.country);
        countryStore.getCountry(id);
    }

    let files;
    async function UploadFile() {
        let thefile = files[0];
        try {
            var ret = await countryStore.importCountryVersion(
                thefile,
                currentCountry.country.id
            );
            if (ret.success) {
                snackbar("success", "file uploaded succesfully");
                countryStore.getCountry(id);
            } else {
                snackbar("error", ret.message);
            }
        } catch (s) {
            snackbar(
                "error",
                "The upload failed, please make sure you are using the multilingual          JSON format (not I11)"
            );
        }
    }
    function addCountryVersion() {
        open(AddCountryVersion, {
            countryVersion: {
                countryId: currentCountry.country.id,
            },
        });
    }

    var saveTimeout = null;
    function saveLangInfo(langText) {
        saveTimeout && clearTimeout(saveTimeout);
        saveTimeout = null;
        saveTimeout = window.setTimeout(async function () {
            saveLangInfoNoWait(langText);
        }, 500);
    }
    function saveLangInfoNoWait(langText) {
        languageTextsStore.saveSingle(langText);
    }
    function sortList(ev) {
        currentCountry.countryVersions = ev.detail;
        save();
    }
    function exportCountry() {
        alert("todo make json export for country");
        // let filename = `Procesdefinitie_${currentProcessDefinition.name}_${currentProcessDefinition.crop.name}.json`;
        // util.downloadFile("api/ProcessDefinitions/detail/" + id, filename);
    }

    function editCountryVersion(countryVersion) {
        navigate("/app/countryversion/" + countryVersion.id);
    }

    async function deleteCountryVersion(countryVersion) {
        if (!confirm("are you sure")) return;
        var result = await countryStore.deleteCountryVersion(countryVersion);
        if (!result.success) {
            snackbar("error", result.message);
        }
        await countryStore.getCountry(id);
    }

    let currencies = [];

    async function getCurrencies() {
        currencies = await countryStore.getCurrencies();
    }
    getCurrencies();

    $: useVersions =
        currentCountry &&
        currentCountry.country &&
        currentCountry.country.countryVersions &&
        currentCountry.country.countryVersions.map((u) => {
            return {
                id: u.id,
                columns: {
                    MainVersion: u.mainVersion,
                    SubVersion: u.subVersion,
                    Published: u.isPublished ? "yes" : "no",
                },
            };
        });

    async function saveCountry() {
        await countryStore.saveCountry(currentCountry.country);
    }

    async function deleteVars() {
        if (!confirm("are you sure you want to clear all the variables..."))
            return;
        countryStore.deleteVariables(id);
    }
    async function downloadAnonymousData() {
        let filename = `anonymousdata.xlsx`;
        util.downloadFile("api/country/getanonymousdata/" + id, filename);
    }
</script>

{#if currentCountry}
    <div style="display:flex;justify-content: right;">
        <button
            class="btn btn-secondary"
            style="cursor:pointer;justify-self:right"
            on:click={downloadAnonymousData}
        >
            Download anonmyous data
        </button>
    </div>

    <button
        style="float: right; position: relative; z-index:999"
        class="btn btn-primary"
        on:click={exportCountry}>Export</button
    >

    <button
        style="float: right; position: relative; z-index:999"
        class="btn btn-primary"
        on:click={deleteVars}>Delete All Variables</button
    >

    <h2 class="col-12 text-primary">
        {currentCountry &&
            currentCountry.country &&
            currentCountry.country.nameKey}
    </h2>
    <Tabs>
        <TabList>
            <Tab>Basic info</Tab>
            <Tab>Versions</Tab>
            <Tab>Languages</Tab>
            {#each currentCountry.languages as lang}
                <Tab>{lang.langName}</Tab>
            {/each}
        </TabList>
        <TabPanel>
            <label for="currentCountry.nameKey">
                NameKey<input
                    id="currentCountry.nameKey"
                    type="text"
                    bind:value={currentCountry.country.nameKey}
                    disabled={true}
                    readonly={true}
                />
            </label><br />
            <label for="currentCountry.currency">
                Currency <select
                    bind:value={currentCountry.country.currencyId}
                    on:change={saveCountry}
                    on:blur={saveCountry}
                >
                    {#each currencies as currency}
                        <option value={currency.id}>{currency.nameKey}</option>
                    {/each}
                </select>
            </label>
            <br />
        </TabPanel>
        <TabPanel>
            <Table
                Title=""
                bind:Items={useVersions}
                AddRowCallBack={addCountryVersion}
                RowClickCallBack={editCountryVersion}
                CustomActionCallBack={deleteCountryVersion}
                CustomActionName="Delete"
            />

            Upload a version:
            <div
                style="display: inline-block; width: 100px; height: 30px; overflow:
            hidden;"
            >
                <div
                    style="display:inline-block;width: 120px; height: 40px; position:
              relative; top: 10px; left:
              0px;text-decoration:underline;cursor:pointer"
                >
                    {#if files}{files[0].name}{:else}Choose file{/if}
                </div>
                <input
                    type="file"
                    id="upload_input"
                    bind:files
                    name="upload"
                    style="font-size: 50px; width: 120px; opacity: 0;
              filter:alpha(opacity=0); position: relative; top: -40px;; left: -20px"
                    title="Use multilingual JSON format"
                />
            </div>
            <button on:click={UploadFile}>Upload</button>
        </TabPanel>

        <TabPanel>
            {#each langs as lang}
                <label for={lang.langName}>
                    <input
                        id={lang.langName}
                        type="checkbox"
                        bind:group={currentCountry.country.langs}
                        on:change={save}
                        value={lang}
                    />
                    {lang}
                </label>
                <br />
            {/each}
        </TabPanel>
        {#each currentCountry.languages as lang}
            <TabPanel>
                {#each lang.langTexts as langText}
                    <label for={langText}>{langText.langLabel}</label>
                    <textarea
                        type="text"
                        class="form-control"
                        placeholder=""
                        bind:value={langText.langValue}
                        required=""
                        id={langText}
                        on:keyup={() => saveLangInfo(langText)}
                        on:change={() => saveLangInfoNoWait(langText)}
                    />
                {/each}
            </TabPanel>
        {/each}
    </Tabs>
{/if}
